import { Dayjs } from 'dayjs';

export class DeliveryStepResult {
  stepOneActive?: boolean;
  stepOneDate?: Dayjs;
  stepOneKey?: string;
  stepTwoActive?: boolean;
  stepTwoDate?: Dayjs;
  stepTwoKey?: string;
  stepThreeActive?: boolean;
  stepThreeDate?: Dayjs;
  stepThreeKey?: string;
  stepFourActive?: boolean;
  stepFourDate?: Dayjs;
  stepFourKey?: string;
  stepFiveActive?: boolean;
  stepFiveDate?: Dayjs;
  stepFiveKey?: string;
  errorStepActive?: boolean;
  errorNumber?: number;
  errorDate?: Dayjs;
  errorKey?: string;

  constructor(data: any = {}) {
    Object.assign(this, data);
  }
}
